module.exports = __webpack_public_path__ + "static/3-ad08eef84a31757b5e46a0af4be8ca3d.jpeg";